import {
    SET_CURSOR_TRACK,
    SET_CURSOR_STEP,
    SET_CURSOR_SHOW} from 'constants/action-types.js';

let initialState = {
    track: 0,
    step: 0,
    show: false,
};

const cursorReducer = (state = initialState, action) => {
    switch (action.type) {
    case SET_CURSOR_TRACK:
        return {
            ...state,
            track: action.payload
        };
    case SET_CURSOR_STEP:
        return {
            ...state,
            step: action.payload
        };
     case SET_CURSOR_SHOW:
        return {
            ...state,
            show: action.payload
        };
    default:
        return state;
    }
};

export default cursorReducer;
